module.exports = vendors_en_52f68f48e23eb25709cd;